module.exports = function(app) {
    app.controller('pages.register.memberInformation', ['$state', '$scope', '$filter', '$window', 'registration', 'registerNotifications', 'contentResourceServices','coremetrics', 'services','brand', 'brandConfig', 'navigation', 'appConfig', 'sessionData',
        function($state, $scope, $filter, $window, registration, registerNotifications, contentResourceServices,coremetrics, services, brand, brandConfig, navigation, appConfig, sessionData) {

            coremetrics.startConversion('MEMBER REGISTRATION', 'REGISTRATION');
            coremetrics.startConversion('IDENTIFICATION STEP', 'REGISTRATION');
            $scope.disableForm = false;
            var user = $state.params.user || {};
            $scope.userType = $state.params.userType;

            if ($scope.userType === "medicareVisitor" || $scope.userType === "highmarkVisitor" ){
                $scope.typeUser="visitor";
            }
            if ($scope.userType === "medicareMember" || $scope.userType === "highmarkMember" ) {
                $scope.typeUser = "member";
            }
            //for highmark shop only
            if ($scope.userType === "highmarkMember" ) {
                $scope.options = [];
                $scope.options.push({name: 'Self', value: 'SELF'});
                $scope.options.push({name: 'Spouse', value: 'SPOUSE'});
                $scope.options.push({name: 'Custodial Parent/Guardian', value: 'CUSTODIAL PARENT/GUARDIAN'});
                $scope.options.push({name: 'Domestic Partner', value: 'DOMESTIC PARTNER'});
                $scope.options.push({name: 'Dependent / Other', value: 'DEPENDENT/OTHER'});
            }
            if ($scope.userType === "highmarkMember" ) {
                $scope.user = {
                    memberId: user.memberId,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    dateOfBirth: user.dateOfBirth,
                    hasProfile: false,
                    isCHIP: false,
                    zip: user.zip,
                    county: user.county,
                    relationship: user.relationship,
                    street:user.street,
                    city:user.city
                };
            }else{
                $scope.user = {
                    memberId: user.memberId,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    dateOfBirth: user.dateOfBirth,
                    hasProfile: false,
                    isCHIP: false,
                    zip: user.zip,
                    county: user.county
                };
            }
            if(user.county){
                $scope.counties = [user.county];
            }
            $scope.chevron.parameters = { user : $scope.user };
            $scope.notifications = [];
            $scope.updateCurrentChevronStep();

            var filterFn = registration.notificationFilter('alert', 'register.memberInformation');
            contentResourceServices.updateResourcesAsync(registerNotifications, filterFn, "Bluecore Notification").then(function(items){
                $scope.notifications = items;
            });

            var activateChevronSteps = function(stepsArray) {
                // Keep only first step, and re-determine the remaining steps each time.
                $scope.chevron.steps = [ $scope.chevron.steps[0] ];

                for (var i=0; i < $scope.nextChevronSteps.length; i++) {
                    if (stepsArray.indexOf($scope.nextChevronSteps[i].id) >= 0)  {
                        $scope.chevron.steps.push($scope.nextChevronSteps[i]);
                    }
                }
                $scope.chevron.steps = $filter('orderBy')($scope.chevron.steps, 'id');
            };

            $scope.nextStep = function() {

                $scope.currentNotification = '';

                if ($scope.registrationForm && $scope.registrationForm.$valid) {
                    coremetrics.elementTag('REGISTRATION:IDENTIFICATION NEXT', 'REGISTRATION');
                    $scope.disableForm = true;

                    $scope.user.brand = $scope.brandData.sharedBrandCode;

                    if($scope.userType == 'medicareVisitor' || $scope.userType == 'highmarkVisitor'){
                        
                        var stateParams =  { user : $scope.user };
                        var activeSteps = [3, 4];

                        activateChevronSteps(activeSteps);

                        $scope.disableForm = false;
                        $scope.currentNotification = '';

                        coremetrics.finishConversion('IDENTIFICATION STEP', 'REGISTRATION');
                        $state.go($scope.getNextStateFromChevron(), stateParams);
                        
                    }else{

                        $scope.currentNotification = registration.notifications.verifyPleaseWait;

                        registration.identifyUser($scope.user).then(function(data) {
                            $scope.user = data.user;
                            var stateParams =  { user : $scope.user };
                            var activeSteps = [3, 4];

                            if (data.user.isCHIP) {
                                activeSteps.push(2);
                            } else {
                                stateParams.identifyResponse = data.response;
                            }
                            activateChevronSteps(activeSteps);

                            $scope.disableForm = false;
                            $scope.currentNotification = '';
                            $state.go($scope.getNextStateFromChevron(), stateParams);

                        }, function(error) {
                            $scope.disableForm = false;
                            var nf = $filter('filter')($scope.notifications, { id: error.returnCodeDescription });
                            $scope.currentNotification = (nf.length > 0 ? error.returnCodeDescription : registration.notifications.defaultError);

                            coremetrics.pageviewTag('REGISTRATION IDENTIFICATION:' + $scope.currentNotification, 'REGISTRATION');
                        });
                    }
                }
            };

            $scope.cancelButton = function() {
                coremetrics.elementTag('REGISTRATION:IDENTIFICATION CANCEL', 'REGISTRATION');
                if($scope.typeUser == "visitor" || $scope.typeUser == "member" ){
                    $window.location = "/#/registration";
                }else{
                    $window.location = '/home/';
                }
            }; 

            var setCountyError = function (errorStatus) {
                var message = '';
                switch (errorStatus) {
                    case 400:
                        message = 'Invalid Zip Code';
                        break;
                    case 500:
                        message = 'Does Not Exist';
                        break;
                    case 'clear':
                        message = '';
                        break;
                    case 'search':
                        message = 'Finding Counties';
                        break;
                    default:
                        message = 'Service Not Found';
                }
                $scope.counties = [{
                    county: message
                }];
                $scope.user.county = $scope.counties[0];
            };  

            $scope.getCounties = function () {

                if ($scope.user.zip && $scope.user.zip.length === 5) {
                    services.cmcrst.countyList().postData(
                        {"zipCode": $scope.user.zip}
                    ).then(function (response) {
                        if (response.data && response.data.payload && response.data.payload.countyList) {
                            $scope.counties = response.data.payload.countyList;
                            $scope.user.county = $scope.counties[0];
                            brand.override = $scope.user.county.brand;
                            brandConfig.update();
                            appConfig.getAll().then(function(response){
                                sessionData.appConfig = angular.extend({}, response);
                            });
                            navigation.update();
                        }
                    },
                    function (error) {
                        var code = error.data && error.data.baseMessage && error.data.baseMessage.returnCode;
                        setCountyError(code);

                    });
                } else {
                    setCountyError('clear');
                }
            };        

        }
    ]);
};
